module.exports = __webpack_public_path__ + "img/footer02.f09c9daa.png";